import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { Link } from "react-router-dom";
import BannerForm from "./BannerForm";
import { ArrowRight } from "react-feather";
import { PRIMARY_TEXT_COLOR } from "../color";
import BrowseJobs from "./BrowseJobs";

const BannerCarousel = ({ primaryColor = "#C16D18" }) => {
  const [currentBanner, setCurrentBanner] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const intervalRef = useRef(null);
  const userdata = JSON.parse(localStorage.getItem("user"));
 
  const banners = [
    {
      id: 1,
      title: "Build Your Career In",
      title2: "Field Audits !",
      subtitle: "The only way to do great work is to love what you do !",
      subtitle2: true,
      subtitle3: true,
      image: "/assets/img/intro.png",
      // primaryButtonText: "Search Audit",
      primaryButtonLink: "/jobs-opening-list",
      secondaryButtonText: `${userdata ? "Explore Now" : "Register Now"}`,
      secondaryButtonLink: `${userdata ? "/jobs-opening-list" : "/register"}`,
    },
    

    {
      id: 2,
      heading:"Help your friends",
      title: "",
      title2: "Join and grow with you !",
      subtitle: "Limited time offer! Refer a friend to & receive ₹200 !",
      image: "/assets/img/ttt.png",
      // primaryButtonText: "Search Audit",
      primaryButtonLink: "/jobs-opening-list",
      secondaryButtonText: "Refer & Earn",
      secondaryButtonLink: "/refer-earn",
      // primaryButtonAction: () => alert("Refer a friend clicked!"),
    },
    {
      id: 3,
      title: "Help your friends",
      title2: "Join and grow with you !",
      subtitle: "Limited time offer! Refer a friend to & receive ₹200 !",
      image: "/assets/img/rb_9814.png",
      // primaryButtonText: "Search Audit",
      primaryButtonLink: "/jobs-opening-list",
      secondaryButtonText: "Refer & Earn",
      secondaryButtonLink: "/refer-earn",
      // primaryButtonAction: () => alert("Refer a friend clicked!"),
    },
  ];
  const nextBanner = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentBanner((prev) => (prev + 1) % banners.length);
    setTimeout(() => setIsAnimating(false), 500);
  };

  const startAutoRotate = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    if (!isHovered) {
      intervalRef.current = setInterval(nextBanner, 5000);
    }
  };

  const stopAutoRotate = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  useEffect(() => {
    startAutoRotate();
    return () => stopAutoRotate();
  }, [isHovered]);

  return (
    <>
      <div
        className="position-relative overflow-hidden"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => {
          setIsHovered(false);
          startAutoRotate();
        }}
      >
        <div
          className="d-flex transition-transform"
          style={{
            transform: `translateX(-${currentBanner * 100}%)`,
            transition: "transform 0.5s ease-in-out",
          }}
        >
          {banners.map((banner) => (
            <div
              key={banner.id}
              className="flex-shrink-0 w-100"
              style={{ minHeight: "550px" }}
            >
              <Container className="h-100 mt-5">
                <Row className="align-items-center h-100">
                  <Col
                    lg={banner.id === 3 ? 6 : 8}
                    sx={12}
                    className="d-flex flex-column justify-content-center text-center text-lg-start"
                  >
                    {banner.id === 3 ? (
                      <div>
                        <BrowseJobs />
                      </div>
                    ) : (
                      <>
                        <h1
                          // className="display-6 fw-bold mb-3 "
                           className="display-6 fw-bold bannerText "
                          style={{ color: primaryColor }}
                        >
                          {banner.title}
                        </h1>
                        {
                          banner?.heading &&  
                        <h1
                          // className="display-6 fw-bold mb-3 "
                           className="display-6 fw-bold mt-md-0 mt-5  bannerText "
                          style={{ color: primaryColor }}
                        >
                          {banner.heading}
                        </h1>
                        }
                        <h1
                          className="display-6 fw-bold mb-3 bannerText"
                          style={{ color: primaryColor }}
                        >
                          {banner.title2}
                        </h1>
                        <p className="lead mb-4" style={{ color: "black" }}>
                          {banner.subtitle}
                          <br />
                          {banner.subtitle2 && (
                            <p className="lead mt-2" style={{ color: "black" }}>
                              Create your Account now & get your registration
                              fee{" "}
                              {/* <span style={{ color: primaryColor }}>
                                {" "}
                                <del>499</del>/- waived off
                              </span> */}
                            </p>
                          )}

                          {banner.subtitle3 && (
                            <p className="lead" style={{ color: "black" }}>
                             
                              <span style={{ color: primaryColor }}>
                                {" "}
                                <del>₹ 499</del>/- waived off
                              </span>
                            </p>
                          )}
                        </p>

                        <div className="">
                          {/* {banner.primaryButtonLink && (
                                                <Link to={banner.primaryButtonLink} className="mr-2">
                                                    <Button
                                                        style={{
                                                            backgroundColor: primaryColor,
                                                            border: 'none'
                                                        }}
                                                    >
                                                        {banner.primaryButtonText}
                                                    </Button>
                                                </Link>
                                            )} */}
                          {banner.secondaryButtonLink && (
                            <Link to={banner.secondaryButtonLink}>
                              <Button
                                style={{
                                  backgroundColor: primaryColor,
                                  border: "none",
                                }}
                                className="d-inline-flex align-items-center px-4 py-2 mt-2"
                              >
                                {banner.secondaryButtonText}
                                <ArrowRight size={20} className="ms-2" />
                              </Button>
                            </Link>
                          )}
                        </div>
                      </>
                    )}
                  </Col>

                  <Col
                    lg={banner.id === 3 ? 6 : 4}
                    sx={12}
                    className="d-flex justify-content-center align-items-center"
                  >
                    {banner.id === 1 && (
                      <img
                        src={banner.image}
                        alt="Banner"
                        className="img-fluid"
                        style={{ maxHeight: "400px", objectFit: "contain" }}
                      />
                    )}
                    {banner.id === 3 && (
                      <img
                        src={banner.image}
                        alt="Banner"
                        className="img-fluid"
                        style={{ maxHeight: "400px", objectFit: "contain" }}
                      />
                    )}

                    {banner.id === 2 && <div className="mb-5"> <BannerForm /></div>}
                  </Col>
                </Row>
              </Container>
            </div>
          ))}
        </div>
      </div>
      {/* Banner Indicators */}
      <div className="d-flex justify-content-center mt-3 pb-3">
        {banners.map((_, idx) => (
          <button
            key={idx}
            className={`btn  mx-2 ${
              idx === currentBanner ? primaryColor : "bg-secondary"
            }`}
            style={{
              padding: "2px 20px",
              // width: '10px',
              // height: '1px',
              cursor: "pointer",
              backgroundColor: idx === currentBanner ? primaryColor : undefined,
            }}
            onClick={() => {
              setCurrentBanner(idx);
            }}
          />
        ))}
      </div>
    </>
  );
};


export default BannerCarousel;
